import { render, staticRenderFns } from "./MyRB.vue?vue&type=template&id=d9244958&"
import script from "./MyRB.vue?vue&type=script&lang=js&"
export * from "./MyRB.vue?vue&type=script&lang=js&"
import style0 from "./MyRB.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MyRB.vue"
export default component.exports